import React from "react";
import { Box } from "@material-ui/core";
import { createTheme, MuiThemeProvider } from "@material-ui/core/styles";
import EasyApplyForm from "./EasyApplyForm";

const THEME = createTheme({
  typography: {
    fontFamily: "'Montserrat', sans-serif",
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
  },
  overrides: {
    MuiOutlinedInput: {
      root: {
        borderRadius: "0.8vh",
        "& $notchedOutline": {
          borderColor: "#C0C0C0",
          borderWidth: "0.15vh"
        },
        "&:hover $notchedOutline": {
          borderColor: "#C0C0C0",
        },
        "&$focused $notchedOutline": {
          borderColor: "#C0C0C0",
          borderWidth: "0.15vh",
        },
        "&$disabled $notchedOutline": {
          borderColor: "#C0C0C0",
        },
      },
    },
  },
});

const ApplyFormContainer = () => {
  return (
    <MuiThemeProvider theme={THEME}>
      <Box>
        <EasyApplyForm />
      </Box>
    </MuiThemeProvider>
  );
};
export default ApplyFormContainer;
